export default {"src":"/_next/static/media/Logout.68c5d6ac.svg","height":14,"width":16};